
import { Component, Vue } from 'vue-property-decorator';
import Trail from './Trail.vue'
import FormIcon from './journeyicons/FormIcon.vue'
import ReturnTrail from './ReturnTrail.vue'
import CalendarIcon from './journeyicons/CalendarIcon.vue'
import GavelIcon from './journeyicons/GavelIcon.vue'
import EndCircle from './journeyicons/EndCircle.vue'

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';

import AppealRecordTranscriptAppLeaveGrantedPg from '../components/AppLeaveGranted/AppealRecordTranscriptAppLeaveGrantedPg.vue';
import FactumAppealBookCertificateAppLeaveGrantedPg from '../components/AppLeaveGranted/FactumAppealBookCertificateAppLeaveGrantedPg.vue';
import BookAppealDateAppLeaveGrantedPg from '../components/AppLeaveGranted/BookAppealDateAppLeaveGrantedPg.vue';
import NoticeOfHearingAppLeaveGrantedPg from '../components/AppLeaveGranted/NoticeOfHearingAppLeaveGrantedPg.vue';
import TheHearingAppLeaveGrantedPg from '../components/AppLeaveGranted/TheHearingAppLeaveGrantedPg.vue';
import CourtOrderAppLeaveGrantedPg from '../components/AppLeaveGranted/CourtOrderAppLeaveGrantedPg.vue';
import AppealProcessCompleteAppLeaveGrantedPg from '../components/AppLeaveGranted/AppealProcessCompleteAppLeaveGrantedPg.vue';

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations'

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application")
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        Trail,
        FormIcon,
        CalendarIcon,
        ReturnTrail,
        GavelIcon,
        EndCircle,
        InstructionWindowFooter,
        PathSidebar,
        AppealRecordTranscriptAppLeaveGrantedPg,
        FactumAppealBookCertificateAppLeaveGrantedPg,
        BookAppealDateAppLeaveGrantedPg,
        NoticeOfHearingAppLeaveGrantedPg,
        TheHearingAppLeaveGrantedPg,
        CourtOrderAppLeaveGrantedPg,
        AppealProcessCompleteAppLeaveGrantedPg
    }
})
export default class AppellantLeaveGrantedJourneyMap extends Vue {

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
    showWindow = false;
    windowTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];

    appealRecordTranscriptContent = false;
    factumAppealBookCertificateContent = false;
    bookAppealDateContent = false;
    noticeOfHearingContent = false;
    theHearingContent = false;
    courtOrderContent = false;
    appealProcessCompleteContent = false;
    updated=0;
    dataReady = false;
    completedTrail :boolean[] = []
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = []

    mounted(){
        this.dataReady = false;

        this.currentStep = this.stPgNo.APP_LEAVE_GRANTED._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.APP_LEAVE_GRANTED).length-1;
        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){        
        activatePage(order, checked, this.currentStep)
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public adjustHeights(index: number, pathHeight: string) {
        this.updated++;
        this.pathHeights[index] = pathHeight;
    }

    public displayWindow(contentType: string){

        this.appealRecordTranscriptContent = false;
        this.factumAppealBookCertificateContent = false;
        this.bookAppealDateContent = false;
        this.noticeOfHearingContent = false;
        this.theHearingContent = false;
        this.courtOrderContent = false;
        this.appealProcessCompleteContent = false;

        if (contentType == "Appeal Record and Transcript"){

            this.windowTitle = "Appeal Record and Transcript";
            this.pathTypes = ["share", "info"];
            this.pathHeights = ['15rem', '0'];
            this.appealRecordTranscriptContent = true;

        } else if (contentType == "Factum, Appeal Book and Certificate of Readiness"){

            this.windowTitle = "The Factum, Appeal Book and Certificate of Readiness";
            this.pathTypes = ["share", "share", "info"];
            this.pathHeights = ['20rem', '0', '0'];
            this.factumAppealBookCertificateContent = true;

        } else if (contentType == "Book Appeal Date"){

            this.windowTitle = "Book Appeal Date";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['2rem'];
            this.bookAppealDateContent = true;

        } else if (contentType == "Notice of Hearing"){

            this.windowTitle = "Notice of Hearing";
            this.pathTypes = ["question", "share"];
            this.pathHeights = ['34rem', '0'];
            this.noticeOfHearingContent = true;

        } else if (contentType == "The Hearing"){
            
            this.windowTitle = "The Hearing";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['6rem'];
            this.theHearingContent = true;

        } else if (contentType == "Court Order"){

            this.windowTitle = "Court Order";
            this.pathTypes = ["info"];
            this.pathHeights = ['6rem'];
            this.courtOrderContent = true;

        } else if (contentType == "Appeal Process Complete"){
            
            this.windowTitle = "Appeal Process Complete";
            this.pathTypes = ["info"];
            this.pathHeights = ['3rem'];
            this.appealProcessCompleteContent = true;
        } 

        this.showWindow = true;
    }
}
